import { configureStore } from "@reduxjs/toolkit";
import sensorTypesReducer from "./sensors/SensorSlice";

export const store = configureStore({
  reducer: {
    sensorTypes: sensorTypesReducer,
  },
});
